export default {
      id: "salaire-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#salaire-usage",
      toString: function () {
        return this.url;
      }
    }